import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import bureaucrat from '../util/Bureaucrat';
import { actions } from './util/actions';
import routerPaths from './util/routerPaths';

function ErrorPane({ apiResponse }) {
  const history = useHistory();
  const routerError = history.location?.state?.error;
  const queryParams = useMemo(
    () => new URLSearchParams(history.location.search),
    [history.location.search],
  );
  const queryError = queryParams.get('error');
  const queryDescription = queryParams.get('error_description');

  if (
    (!apiResponse || apiResponse.action !== actions.error) &&
    !routerError &&
    !queryError
  ) {
    if (history.location.pathname === routerPaths.ERROR) {
      history.push(routerPaths.HOME);
    }

    return null;
  }

  const errorStatus = apiResponse?.error || routerError?.name || queryError;
  const errorDescription =
    apiResponse?.description || routerError?.description || queryDescription;

  return (
    <>
      Oops...
      <br />
      Something seems to have gone wrong. <a href="/">Click here</a> to refresh.
      If you continue to get this error,{' '}
      <a href={bureaucrat.logoutUrl}>logout</a> and log back in.
      <div>
        <br />
        <label htmlFor="errorStatus">Error:</label>{' '}
        <p id="errorStatus">{errorStatus || 'Error'}</p>
      </div>
      <div>
        <label htmlFor="errorDescription">Description:</label>
        <pre>
          <span id="errorDescription">{errorDescription}</span>
        </pre>
      </div>
    </>
  );
}

ErrorPane.propTypes = {
  apiResponse: PropTypes.object,
};

export default ErrorPane;
